export const swrKeys = {
  fetchCrfDownloadJobs: 'fetchCrfDownloadJobs',
  fetchQuestionnaireAnswers: ({
    trialUid,
    patientUid,
  }: {
    trialUid: string
    patientUid: string
  }) => `/trials/${trialUid}/patients/${patientUid}/questionnaireAnswers`,

  //e-Consent
  fetchApprovedIcfDocuments: ({
    trialUid,
    trialHospitalUid,
  }: {
    trialUid: string
    trialHospitalUid: string
  }) =>
    `trials/${trialUid}/trial_hospitals/${trialHospitalUid}/icf_documents?type=approved`,
  fetchIcfDocument: ({
    trialUid,
    trialHospitalUid,
    icfDocumentUid,
  }: {
    trialUid: string
    trialHospitalUid: string
    icfDocumentUid: string
  }) =>
    `trials/${trialUid}/trial_hospitals/${trialHospitalUid}/icf_documents/${icfDocumentUid}`,
  fetchIcfDocumentRevision: ({
    trialUid,
    trialHospitalUid,
    icfDocumentRevisionUid,
  }: {
    trialUid: string
    trialHospitalUid: string
    icfDocumentRevisionUid: string
  }) =>
    `trials/${trialUid}/trial_hospitals/${trialHospitalUid}/icf_document_revisions/${icfDocumentRevisionUid}`,
  getIcfDocumentVideoStreamUrl: ({
    trialUid,
    icfDocumentRevisionUid,
  }: {
    trialUid: string
    icfDocumentRevisionUid: string
  }) =>
    `/trials/${trialUid}/icf_document_revisions/${icfDocumentRevisionUid}/video_stream_url`,
  fetchNextIcfDocumentRevisionTemplate: ({
    trialUid,
    trialHospitalUid,
    icfDocumentUid,
  }: {
    trialUid: string
    trialHospitalUid: string
    icfDocumentUid: string
  }) =>
    `trials/${trialUid}/trial_hospitals/${trialHospitalUid}/icf_documents/${icfDocumentUid}/next_revision`,
  fetchIcfDocumentSetList: ({
    trialUid,
    trialHospitalUid,
  }: {
    trialUid: string
    trialHospitalUid: string
  }) =>
    `trials/${trialUid}/trial_hospitals/${trialHospitalUid}/icf_document_sets`,
  fetchIcfDocumentSet: ({
    trialUid,
    trialHospitalUid,
    icfDocumentSetUid,
  }: {
    trialUid: string
    trialHospitalUid: string
    icfDocumentSetUid: string
  }) =>
    `trials/${trialUid}/trial_hospitals/${trialHospitalUid}/icf_documents_sets/${icfDocumentSetUid}`,
} as const
